export const RESOLVED_THEMES = Object.freeze({
  DARK: "dark",
  LIGHT: "light",
});

export const THEME_PREFERENCES = Object.freeze({
  DARK: "dark",
  LIGHT: "light",
  SYSTEM: "system",
});

export const THEME_STORAGE_KEY = "netpad.themePreference";

export const SYSTEM_THEME_QUERY = "(prefers-color-scheme: dark)";
